module.exports = __webpack_public_path__ + "img/console.506b74a1.svg";